export class CurrentClientUserSelection {
  public constructor(public readonly clientId: string) {}
}
